import {match, Pattern} from 'ts-pattern';

import {
  FieldGroupDefinitionResponseBody,
  StageSequenceDefinitionResponseBody,
} from '@dms/api/settings';

export function getVisibleStageSequences(
  allowedStageIds: FieldGroupDefinitionResponseBody['allowedStageIds'],
  stageSequences: StageSequenceDefinitionResponseBody[]
) {
  return match(allowedStageIds)
    .with(Pattern.nullish, () => stageSequences)
    .with(Pattern.array(Pattern.string), (stageIds) => {
      const allowedStageIdSet = new Set(stageIds);

      return stageSequences
        .map((stageSequence) => ({
          ...stageSequence,
          stages: stageSequence.stages.filter((stage) => allowedStageIdSet.has(stage.id)),
        }))
        .filter((stageSequence) => stageSequence.stages.length > 0);
    })
    .exhaustive();
}
